import { render, staticRenderFns } from "./nameEdition.vue?vue&type=template&id=8d37cdf6"
import script from "./nameEdition.vue?vue&type=script&lang=js"
export * from "./nameEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports